<template>
	<div class="profile">
		<div class="row">
			<div class="col-md-3 border-end">
				<div class="card mb-3">
					<div class="card-body">
						<div class="d-flex flex-column align-items-center text-center p-3 py-5">
							<img class="rounded-circle mt-3" width="150px" src="https://st3.depositphotos.com/15648834/17930/v/600/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg">
							<span class="font-weight-bold">{{ (isCpil) ? 'Coordinador de Publicaciones' : 'Suscriptor' }}</span>
							<span class="text-black-50">{{ objectClient.email }}</span>
							<br>
							<div class="d-grid gap-2">
								<router-link :to="'/changepassword/' + objectClient.token" class="btn btn-entity-alegria btn-sm" type="button">Cambiar Contraseña</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-5 border-end">
				<div class="card mb-3">
					<div class="card-body">
						<div class="p-3 pt-3">
							<div class="d-flex justify-content-between align-items-center mb-3 title-width-icon">
								<h4 class="text-right"
									>Mis Datos
								</h4>
								<svg class="float-end text-secondary icon" width="24" height="24" role="img" title="Recargar información" @click="clientConnection">
									<use xlink:href="#arrow-clockwise"/>
								</svg>
							</div>
							<div class="row mt-2">
								<div class="col-md-6">
									<label for="inputName" class="labels">Nombres</label>
									<input type="text" class="form-control" id="inputName" v-model="objectClient.name">
								</div>
								<div class="col-md-6">
									<label for="inputSurname" class="labels">Apellidos</label>
									<input type="text" class="form-control" id="inputSurname" v-model="objectClient.surname">
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-md-6">
									<label for="inputNumberDocument" class="labels">RUT</label>
									<input type="text" class="form-control" id="inputNumberDocument" placeholder="ej: 12345678-9" v-model="objectClient.number_document">
								</div>
								<div class="col-md-6">
									<label for="inputCelPhone" class="labels">Celular</label>
									<input type="text" class="form-control" id="inputCelPhone" placeholder="ej: 56912345678" v-model="objectClient.phone">
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-md-12">
									<label for="inputBirthdate" class="labels">Fecha de Nacimiento</label>
									<input type="date" class="form-control" id="inputBirthdate" v-model="objectClient.birthdate">
								</div>
							</div>
							<div class="mt-5 text-center"><button class="btn btn-primary" type="button" @click="saveClientConnectionLocal" :disabled="disabledBtnSaveClient">Guardar Datos</button></div>
						</div>
						<hr v-if="isCpil">
						<div class="p-3 py-4" v-if="isCpil">
							<div class="d-flex justify-content-between align-items-center experience">
								<h1 class="h5">Direcciones</h1>
								<span class="border px-3 p-1 add-experience" data-bs-toggle="modal" data-bs-target="#addressModal" @click="showAddressModal">
									<i class="fa fa-plus"></i>&nbsp;Nueva
								</span>
							</div>
							<div v-if="isCpil">
								<ul class="list-group list-group-flush list-address">
									<li class="list-group-item" v-for="(item, index) in objectClient.address" :key="index">
										<svg class="float-end text-danger icon" width="12" height="12" role="img" v-if="disabledBtnSaveAddress" title="Dirección incompleta">
											<use xlink:href="#trash3"/>
										</svg>
										<div>
											{{ item.street }} - {{ item.comuna }}
										</div>
										<i>Transporte: <span class="badge" :class="'text-bg-' + item.transport.color">{{ item.transport.name }}</span></i>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-4">
				<div class="card mb-3">
					<div class="card-body">
						<div class="p-3 py-4">
							<div class="d-flex justify-content-between align-items-center experience title-width-icon">
								<h1 class="h5">Iglesia</h1>
								<svg class="float-end text-primary icon" width="14" height="14" v-if="!isCpil && objectClient.extras.churchs != undefined && objectClient.extras.churchs.length == 0" role="img" data-bs-toggle="modal" data-bs-target="#churchModal" @click="showSelectChurchModal" title="Cambiar Iglesia">
									<use xlink:href="#plus-circle"/>
								</svg>
							</div>
							<div>
								<ul class="list-group list-group-flush">
									<li class="list-group-item title-width-icon" v-for="(item, index) in objectClient.extras.churchs" :key="index">
										<svg class="float-end text-warning icon" width="14" height="14" v-if="!isCpil" role="img" data-bs-toggle="modal" data-bs-target="#churchModal" @click="showSelectChurchModal" title="Cambiar Iglesia">
											<use xlink:href="#pencil-square"/>
										</svg>
										<div>
											<b>{{ item.type_church.name }} {{ item.name }}</b>
										</div>
										<div><i>Distrito: {{ item.district.name }} ({{ item.entity.synthetic }})</i></div>
										<div title="Coordinador de publicaciones local" v-if="!isCpil">CPIL: 
											<span v-if="item.client != null">
												{{ item.client.name }} {{ item.client.surname }}
											</span>
											<span v-else class="text-danger">
												Esta Iglesia no tiene un CPIL asignado
											</span>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="alert alert-primary mt-2" role="alert">
  			Es <strong>IMPORTANTE</strong> que tenga actualizado sus datos, así nos podremos comunicar de forma efectiva con usted
		</div>
		<br>
		<!-- Modal Selection Church -->
		<div class="modal fade" id="churchModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" v-if="!isCpil">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header p-3 pb-4 border-bottom-0">
						<h3 class="fw-bold mb-0">Seleccione una iglesia</h3>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body p-3 pt-0">
						<churchs-input-component @actionSelectItem="selectItemChurch" :searchChurch="true" ref="churchsInputComponent"></churchs-input-component>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal" ref="btnCloseChurchModal">Cerrar</button>
						<button type="button" class="btn btn-sm btn-primary" :disabled="!(newChurch.id > 0)" @click="saveClientChurchLocal">Guardar</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal New Address -->
		<div class="modal fade" id="addressModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header p-3 pb-4 border-bottom-0">
						<h3 class="fw-bold mb-0">Nueva Dirección</h3>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body p-3 pt-0">
						<div class="row">
							<div class="col-12">
								<div class="form-floating mb-3">
									<input type="text" class="form-control rounded-3" placeholder="Santiago" v-if="searchingComunas" disabled>
									<select class="form-select form-select-lg mb-3 fs-6" aria-label=".form-select-lg example" :disabled="searchingComunas" v-model="objectAddress.comuna_id" v-else>
										<option selected disabled value="0">Selecciones su comuna</option>
										<option v-for="(item, index) in listComunas" :key="index" :value="item.id"><b>{{ item.name }}</b>, {{ item.region }}</option>
									</select>
									<label v-if="searchingComunas">Buscando comunas . . .</label>
									<label v-else>Comuna</label>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<div class="form-floating mb-3">
									<select class="form-select form-select-lg mb-3 fs-6" aria-label=".form-select-lg example"
										:disabled="objectAddress.comuna_id == 0"
										v-model="objectAddress.transport_id"
										@change="setAddress">
										<option selected disabled value="0">Selecciones el Trasporte</option>
										<option v-for="(item, index) in listTrasportsFilterRegion" :key="index" :value="item.id">
											{{ item.name }}
										</option>
									</select>
									<label>Transporte</label>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-9">
								<div class="form-floating mb-3">
									<input type="text" class="form-control rounded-3" placeholder="ej: Santa Elena" v-model="objectAddress.text" :disabled="notModifyAddress || objectAddress.comuna_id == 0">
									<label>Calle</label>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-floating mb-3">
									<input type="text" class="form-control rounded-3 text-center" placeholder="1038" v-model="objectAddress.number" :disabled="notModifyAddress || objectAddress.comuna_id == 0">
									<label>Número</label>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-5">
								<div class="form-floating mb-3">
									<input type="text" class="form-control rounded-3" placeholder="Dpto 98" v-model="objectAddress.extra" :disabled="notModifyAddress || objectAddress.comuna_id == 0">
									<label>Nº Departamento o casa</label>
								</div>
							</div>
						</div>
						<div class="card mb-3">
							<div class="card-body">
								<svg class="float-end text-danger" width="12" height="12" role="img" v-if="disabledBtnSaveAddress" title="Dirección incompleta">
									<use xlink:href="#exclamation-triangle-fill"/>
								</svg>
								<svg class="float-end text-success" width="12" height="12" role="img" v-else>
									<use xlink:href="#check-lg"/>
								</svg>
								<strong>Dirección Completa</strong>
								<p class="card-text">{{ addressFinish }}</p>
							</div>
						</div>
						<div class="form-check">
							<input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="objectAddress.send">
							<label class="form-check-label" for="flexCheckDefault">
								Dirección de envío predeterminada
							</label>
						</div>
						<hr>
						<div class="alert alert-info d-flex align-items-center" role="alert">
							<svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Danger:"><use xlink:href="#exclamation-triangle-fill"/></svg>
							<div>
							    Asegúrese que el transporte elegido llegue a su comuna y que tenga servicio a domicilio, de lo contrario el pedido quedará en la agencia para su retiro
  							</div>
						</div>
						<div></div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal" ref="btnCloseAddressModal">Cerrar</button>
						<button type="button" class="btn btn-sm btn-primary" @click="saveClientAddressLocal" :disabled="disabledBtnSaveAddress">Guardar</button>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import mixin from '@/mixins'
	import axiosAWN from '@/mixins/axiosAWN.js'
	import axiosSystem from '@/mixins/axiosSystem.js'
	import client from '@/mixins/client.js'
	import address from '@/mixins/address.js'
	
	import ChurchsInputComponent from '@/components/ChurchsInputComponent.vue'

	export default {
		name: 'Profile',
		mixins: [mixin, axiosAWN, axiosSystem, client, address],
		data() {
			return {
				savingClient: false,
				newChurch: {}
			}
		},
		computed: {
			street() {
				this.objectAddress.street = this.objectAddress.text.trim()
				if(this.objectAddress.street == '') {
					return this.objectAddress.street
				}

				this.objectAddress.street+= (this.objectAddress.number.trim() != '') ? ' ' + this.objectAddress.number.trim() : ' S/N'
				this.objectAddress.street+= (this.objectAddress.extra.trim() != '') ? ', ' + this.objectAddress.extra.trim() : ''

				return this.objectAddress.street
			},
			addressFinish() {
				let addressFull = this.street
				if(addressFull.trim() == '') {
					return addressFull.trim()
				}

				if(this.objectAddress.comuna_id > 0) {
					let index = this.listComunas.map((el) => parseInt(el.id)).indexOf(parseInt(this.objectAddress.comuna_id))
					if(index > -1) {
						addressFull+= ' - ' + this.listComunas[index].name
					}
				}
				return addressFull
			},
			disabledBtnSaveAddress() {
				if(this.objectAddress.text.trim().length < 3) {
					return true
				}
				if(this.objectAddress.comuna_id == 0) {
					return true
				}
				if(this.objectAddress.transport_id == 0) {
					return true
				}
				return false
			},
			disabledBtnSaveClient() {
				if(!this.checkDataLength(this.objectClient.name, 3)) {
					return true
				}
				if(!this.checkDataLength(this.objectClient.surname, 3)) {
					return true
				}
				if(!this.checkDataLength(this.objectClient.phone, 9, '==')) {
					return true
				}
				if(!this.checkDigitoRUT(this.objectClient.number_document)) {
					return true
				}
				if(this.savingClient == true) {
					return this.savingClient
				}
				return !this.validateEmail(this.objectClient.email)
			},
			isCpil() {
				if(typeof this.objectClient.extras.cpil)
					return this.objectClient.extras.cpil
				return false
			},
			listTrasportsFilterRegion() {
				let list = []

				if(this.objectAddress.comuna_id > 0) {
					let index = this.listComunas.map((el) => parseInt(el.id)).indexOf(parseInt(this.objectAddress.comuna_id))
					if(index > -1) {
						let ind = this.listTrasports.map((el) => parseInt(el.region_id)).indexOf(parseInt(this.listComunas[index].region_id))
						list = this.listTrasports.filter((item) => {
									if(ind > -1) {
										if(item.region_id == this.listComunas[index].region_id)
											return true
										return false
									}
									return true
								})
					}
				}
				
				return list
			},
			notModifyAddress() {
				let index = this.listComunas.map((el) => parseInt(el.id)).indexOf(parseInt(this.objectAddress.comuna_id))
				if(index > -1) {
					let ind = this.listTrasports.map((el) => parseInt(el.region_id)).indexOf(parseInt(this.listComunas[index].region_id))
					if(ind > -1) {
						if(this.listTrasports[ind].street != undefined) {
							return true
						}
					}
				}
				return false
			}
		},
		components: {
			'churchs-input-component': ChurchsInputComponent,
		},
		methods: {
			initModuleLocal() {
				document.title = 'Mis datos - Suscripción ACES Chile'
				console.log('Estamos en el control de acceso (' + this.$el.className + ')')
				this.clientConnection()
			},
			clientConnection() {
				this.savingClient = true
				let url = this.getApiBackend + 'clientConnection'
				this.axiosAWNasyncBlock('Estamos cargando sus datos', 'POST', url, 'clientConnectionResult', null)
			},
			clientConnectionResult(response) {
				if(response.data.success = true) {
					this.savingClient = false
					this.setObjectClient(response.data.data)
					if(this.isCpil) {
						this.getAddressLocal()
						this.getAllComunas()
					}
				}
			},
			clientConnectionResultError(error) {
				this.$awn.alert('No se pudo recuperar su información')
				console.log(error)
			},
			getAddressLocal() {
				let url = this.getApiBackend + 'clientConnection/address'
				this.axiosAWNasyncBlock('Estamos buscando sus direcciones', 'POST', url, 'getAddressLocalResult', null)
			},
			getAddressLocalResult(response) {
				if(response.data.success == true) {
					this.objectClient.address = response.data.data
				}
			},
			saveClientAddressLocal() {
				let url = this.getApiBackend + 'clientConnection/address/register'
				console.log(url, this.objectAddress)
				this.axiosAWNasyncBlock('Estamos guardando su nueva direccion', 'POST', url, 'saveClientAddressResult', this.objectAddress)
			},
			saveClientAddressResult(response) {
				if(response.data.success == true) {
					this.$awn.success('Dirección agregada con exito')
					this.objectClient.address.push(response.data.data)
					this.setClientSystem(this.objectClient)
					this.$refs.btnCloseAddressModal.click()
				} else {
					this.$awn.warning('Algo no salió bien, intentelo nuevamente')
					console.log(response)
				}
			},
			saveClientAddressResultError(error) {
				this.$awn.alert('No se pudo Guardar la nueva dirección')
				console.log(error)
			},
			saveClientChurchLocal() {
				if(this.newChurch.id > 0) {
					let url = this.getApiBackend + 'clientConnection/changeChurch'
					let data = {
							churchId: this.newChurch.id
						}
					this.axiosAWNasyncBlock('Estamos guardando su nueva iglesia', 'POST', url, 'saveClientChurchResult', data)
				}
			},
			saveClientChurchResult(response) {
				if(response.data.success == true) {
					this.$refs.btnCloseChurchModal.click()
					this.objectClient.extras.churchs = response.data.data.church
					this.setClientSystem(this.objectClient)
					this.$awn.success('Se ha cambiado con exito su iglesia')
				}
			},
			saveClientChurchResultError() {
				this.savingClient = false
				this.$awn.alert('No se pudo asignar la iglesia')
				console.log(error)
			},
			saveClientConnectionLocal() {
				this.savingClient = true
				let url = this.getApiBackend + 'clientConnection/update'
				let data = {
						name: this.objectClient.name,
						surname: this.objectClient.surname,
						number_document: this.objectClient.number_document,
						birthdate: this.objectClient.birthdate,
						phone: this.objectClient.phone,
					}
				this.axiosAWNasyncBlock('Estamos guardando su información', 'POST', url, 'saveClientConnectionResult', data)
			},
			saveClientConnectionResult(response) {
				this.savingClient = false
				if(response.data.success = true) {
					this.setClientSystem(this.objectClient)
					this.$awn.success('Datos Guardados')
				} else {
					this.$awn.warning('Algo no salió bien, intentelo más tarde')
				}
			},
			saveClientConnectionResultError(error) {
				this.savingClient = false
				this.$awn.alert('No se pudo guardar sus datos')
				console.log(error)
			},
			selectItemChurch(item) {
				if(item.id > 0) {
					this.newChurch = item
				}
			},
			setAddress() {
				let index = this.listTrasports.map((el) => parseInt(el.id)).indexOf(parseInt(this.objectAddress.transport_id))
				if(index > -1) {
					if(this.listTrasports[index].street != undefined) {
						this.objectAddress.text = this.listTrasports[index].street
						this.objectAddress.number = this.listTrasports[index].number
						this.objectAddress.extra = ""
						this.objectAddress.comuna_id = this.listTrasports[index].comuna_id
					}
				}
			},
			showAddressModal() {
				this.clearObjectAddress()
			},
			showSelectChurchModal() {
				this.newChurch = {}
				this.$refs.churchsInputComponent.$refs.clear.click()
			},
		},
		mounted () {
			this.initModule()
		}
	}
</script>

<style>
	.profile-button {
		background: rgb(99, 39, 120);
		box-shadow: none;
		border: none
	}

	.profile-button:hover {
		background: #00b7bd
	}

	.profile-button:focus {
		background: #00b7bd;
		box-shadow: none
	}

	.profile-button:active {
		background: #00b7bd;
		box-shadow: none
	}

	.back:hover {
		color: #00b7bd;
		cursor: pointer
	}

	.add-experience:hover {
		background: #00b7bd;
		color: #fff;
		cursor: pointer;
		border: solid 1px #00b7bd
	}
</style>